import { components } from "@api/schema";
import api from "@api";

const BASE_PATH = "/users/sessions";

export type IAuth = components["schemas"]["auth"];
export type ISession = components["schemas"]["session"];

export const signIn = async (args: IAuth) => {
  const response = await api.post<IAuth, ISession>(BASE_PATH, args);
  const token = response.data.token;
  api.setAuthToken(token);
  localStorage.setItem("Authorization", token);
  return response;
};
